import React from "react";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft, LuHome, LuShieldAlert } from "react-icons/lu";

import ErrorState from "../../components/errors/ErrorState";
import QuickLinks from "../../components/errors/QuickLinks";
import AppLayout from "../../components/layout/AppLayout";
import Breadcrumb from "../../components/layout/Breadcrumb";
import Button from "../../components/ui/Button";
import { cardClass, pageTitleClass } from "../../components/ui/styles";
import { route } from "../../static/route";
import { BreadcrumbType } from "../../types/common";

const breadcrumbItems: BreadcrumbType[] = [
  { label: "હોમ", href: route.dashboard },
  { label: "ઍક્સેસ નકારી" },
];

type Props = {
  message?: string;
};

const ForbiddenPage = ({ message }: Props) => {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <div className="mb-2 md:mb-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="flex items-center mb-4 md:mb-6 mt-2">
        <h1 className={pageTitleClass}>ઍક્સેસ નકારી</h1>
      </div>

      <div className="space-y-4 md:space-y-6">
        <div className={cardClass}>
          <ErrorState
            icon={<LuShieldAlert className="h-6 w-6" />}
            code="403"
            title="તમને આ પેજ જોવાની પરવાનગી નથી"
            description={
              message ||
              "આ પેજ ખોલવાની પરવાનગી તમારા એકાઉન્ટ પાસે નથી. જો તમને આની જરૂર હોય તો કૃપા કરીને તમારા એડમિનનો સંપર્ક કરો."
            }
          >
            <Button
              variant="primary"
              className="w-full sm:w-auto"
              onClick={() => navigate(route.dashboard)}
            >
              <LuHome className="h-4 w-4" />
              ડેશબોર્ડ પર જાઓ
            </Button>

            <Button
              variant="outline"
              className="w-full sm:w-auto"
              onClick={() => navigate(-1)}
            >
              <LuArrowLeft className="h-4 w-4" />
              પાછા જાઓ
            </Button>
          </ErrorState>
        </div>

        <QuickLinks />
      </div>
    </AppLayout>
  );
};
export default ForbiddenPage;
